// Shared PWA environment checks — used by the install prompt, the push
// notification hook, and their Settings-page counterparts.

export function isIos() {
  return /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
}

export function isStandalone() {
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

// Which "add it from your browser" steps to show first on Settings:
// "ios" (Safari on iPhone / iPad), "mac" (Safari on a Mac) or "chrome"
// (Chrome, Edge and other Chromium browsers, the default). iPadOS reports a
// Mac user agent, so a touch screen on "Macintosh" counts as iOS.
export function installGuideFor(ua = window.navigator.userAgent, maxTouchPoints = window.navigator.maxTouchPoints || 0) {
  if (/iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && maxTouchPoints > 1)) return "ios";
  if (/Macintosh/.test(ua) && /Safari\//.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS/.test(ua)) return "mac";
  return "chrome";
}
